(function ($, Cobalt, undefined) {
    Cobalt.ProfileFields = {
        dependentScripts: function () { return [{ dependency: Cobalt.Forms, name: "Cobalt.Forms" }]; },
        initialized: false,
        initialize: function () {
            
            // Setup the sortable functionality of a profile field group.
            var groupManager = $("#profile-field-groups-manager");
            groupManager.sortable({
                handle: ".icon-drag-handle:not(.icon-field-drag-handle)",
                items: "> li.group-item",
                stop: function () {
                    groupManager.mask();
                    var items = groupManager.find("li.profile-field-group-normal");
                    var ids = [];
                    for (var i = 0; i < items.length; i++) {
                        ids[i] = $(items[i]).attr("data-group-id");
                    }
                    var routeValues = { groupIDs: ids.join("-") };
                    var url = Cobalt.Routes.Instance.CPProfileFieldGroupUpdateDisplayOrder();
                    Cobalt.Utils.postWithToken(url, routeValues).done(function () {
                        groupManager.unmask();
                    });
                }
            });

            // Setup the sortable functionality of the profile fields within a group.
            var fieldManager = $(".profile-fields-manager");
            fieldManager.sortable({
                handle: ".icon-field-drag-handle",
                items: "> li.field-item",
                start: function(event, ui) {
                    var item = ui.item;
                    item.parents(".group-item").siblings().find(".profile-fields-manager .placeholder").show();
                },
                stop: function (event, ui) {
                    var item = ui.item;
                    item.parents(".group-item").siblings().find(".profile-fields-manager .placeholder").hide();
                    
                    fieldManager.mask();
                    var items = item.parent().find("li.profile-field-normal");
                    var ids = [];
                    for (var i = 0; i < items.length; i++) {
                        ids[i] = $(items[i]).attr("data-field-id");
                    }
                    var routeValues = { fieldIDs: ids.join("-") };
                    var url = Cobalt.Routes.Instance.CPProfileFieldUpdateDisplayOrder();
                    Cobalt.Utils.postWithToken(url, routeValues).done(function () {
                        fieldManager.unmask();
                    });                    
                }
            });

            // Setup the ability to drop a field between groups.
            fieldManager.droppable({
                hoverClass: "drop-hover",
                accept: "li.field-item",
                drop: function(event, ui) {
                    var item = ui.draggable;
                    var groupID = $(this).parents(".group-item").attr("data-group-id");
                    if (item.attr("data-group-id") !== groupID) {
                        var clone = item.clone().removeAttr("style").attr("data-group-id", groupID);
                        item.remove();
                        $(this).append(clone);
                        Cobalt.triggerHtmlInsert(clone);
                        $(".profile-fields-manager .placeholder").hide();
                        $(this).mask();
                        var data = { fieldID: clone.attr("data-field-id"), newGroupID: groupID };
                        var url = Cobalt.Routes.Instance.CPProfileFieldChangeGroup();
                        Cobalt.Utils.postWithToken(url, data).done(function () {
                            $(this).unmask();
                        });                        
                    }
                }
            });

            // Setup the See Deleted checkbox.
            $("#profile-fields-sortable .j-see-deleted").on("change", function() {
                var checked = $(this).is(":checked");
                var parent = $("#profile-fields-sortable");
                if (checked) {
                    parent.addClass("show-deleted");
                } else {
                    parent.removeClass("show-deleted");
                }
            });

            Cobalt.runOnHtmlInsert(function () {
                // Hook the dialogClose event to set initialized back to false so that new forms will be re-bound.
                $("#profile-field-form").closest(".ui-dialog-content").bind('dialogclose', function () {
                    Cobalt.ProfileFields.initialized = false;
                });
                
                if (!Cobalt.ProfileFields.initialized) {
                    var profileFieldForm = $("#profile-field-form");
                    if (profileFieldForm.length > 0) {                        
                        Cobalt.ProfileFields.bindFieldLists();
                        Cobalt.ProfileFields.bindTypeField();
                        Cobalt.ProfileFields.bindValidatorsField();
                        Cobalt.ProfileFields.initialized = true;
                    }
                }
            });
        },
        moveFileField: function (index, value) {
            $(value).find(".sort-gripper").hide();
            $(value).find(".remove-link").hide();
            var fileInputField = $(value).find("input");
            var newName = fileInputField.attr("name").split("-")[0] + "-" + (index + 1).toString();
            fileInputField.attr("name", newName);
            var textInputField = $($("#field-values .form-field")[index]);
            textInputField.find("input[type=text]").after(fileInputField);
        },
        bindFieldLists: function() {
            // Clicking the new entry link on the values field should also add a new field to the image field.
            $("#field-values .field-list-new-entry").on("click", function () {
                var fileFieldNewEntryField = $("#field-images .field-list-new-entry");
                fileFieldNewEntryField.click();
                var valuesFields = $("#field-values .form-field");
                var lastIndex = valuesFields.length;
                valuesFields.find("input[name*=values-]").removeClass("hide").show();
                valuesFields.find("input[name=values-" + lastIndex + "]").focus();
            });
        },
        bindValidatorsField: function () {
            // Bind the hiding and showing of validators based on the options selected.
            var validatorField = $("#field-validator");
            if (validatorField.length > 0) {
                validatorField.on("change", function() {
                    var selected = $(this).find(":selected");
                    if (selected.length > 0) {
                        var id = "#" + selected.attr("data-additional-validator-id");
                        $(".additional-validator").hide();
                        $(id).removeClass("hide").show().find(".additional-validator").show();
                    }
                });
            }
        },
        bindTypeField: function() {
            var valuesField = $("#field-values");
            var optionLabeling = $("#option-labeling");
            var validators = $("#validators");
            valuesField.find("input[type=text]").removeClass("hide");
           
            var fieldType = $("#field-type");
            if (fieldType.length > 0) {
                
                if (fieldType.find(":selected").attr("data-allow-multiple-values") === "true") {
                    valuesField.removeClass("hide").show();
                }
                
                if (fieldType.find(":selected").attr("data-allow-additional-validation") === "true") {
                    validators.removeClass("hide").show();
                    var id = "#" + validators.find("option:selected").attr("data-additional-validator-id");
                    $(id).removeClass("hide").show().find(".additional-validator").show();
                }

                // As the type field is changed, make sure that the proper options for the form are shown/hidden.
                fieldType.on("change", function () {
                    $(".field-errors[htmlfor=field-values]").remove();
                    var selected = $(this).find(":selected");
                    var allowMultipleInputs = selected.attr("data-allow-multiple-values") === "true";
                    var allowValidation = selected.attr("data-allow-additional-validation") === "true";

                    if (selected.length > 0) {
                        if (selected.val() === "") {
                            valuesField.hide();
                            optionLabeling.hide();
                        } else {
                            if (allowMultipleInputs) {
                                valuesField.removeClass("hide").show();
                                optionLabeling.html("Field Labels").show();
                            } else {
                                optionLabeling.hide();
                                valuesField.hide();
                            }
                            
                            if (allowValidation) {
                                validators.removeClass("hide").show();
                            } else {
                                validators.hide();
                            }
                        }
                    }
                });
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.ProfileFields.js